<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey"
    :submit="submit"
    :status="status"
    labelBack="Atrás"
    :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/car_brands'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Nombre</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.name"
                  label="Nombre"
                  solo
                  hide-details="auto"
                  class="input-base"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider
                  ref="size_spot_id"
                  rules="required"
                  v-slot="{ errors }"
              >
              <div class="label-base pb-1">Tamaño</div>
                <v-select
                    :error-messages="errors"
                    v-model="data.size_spot_id"
                    :items="size_spots" item-text="title" item-value="id"
                    label="Tamaño"
                    solo
                    hide-details="auto"
                    class="input-base"
                    append-icon="$caretDownFormIcon"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>   
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="length"
                rules="positive|integer|required"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Longitud</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.length"
                  type="Number"
                  label="Longitud"
                  solo
                  hide-details="auto"
                  class="input-base no-spinner"
                  >
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="() => data.length++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="() => data.length--">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>                
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="width"
                rules="positive|integer|required"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Ancho</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.width"
                  type="Number"
                  label="Ancho"
                  solo
                  hide-details="auto"
                  class="input-base no-spinner"
                  >
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="() => data.width++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="() => data.width--">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col  class="py-0 px-2">
              <ValidationProvider
                      ref="car_picture" rules=""
                      v-slot="{ errors }"
              >
              <div class="label-base pb-1">Foto</div>
                <Upload
              
                        :error-messages="errors"
                        accept="image/png, image/jpeg, image/jpg"
                        placeholder="Foto"
                        prepend-icon="fas fa-camera"
                        label=""                        
                        :multiple="false"
                        :onSelectedPicture="onSelectedPicture"
                ></Upload>
                <v-img
                        :src="car_picture"
                        width="200"
                        style="margin: auto"
                ></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>        
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import Upload from "@/components/Upload";
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm, Upload},
    computed: {
      ...mapState({
        status: state => state.Car_models.status,
        size_spots: state => state.Size_spots.list,
      })
    },
    async created() {
      const self = this;
      let filters = {};

      if(this.$route.params.brand_id) {
        this.data.brand_id = this.$route.params.brand_id
        filters.brand_id = this.$route.params.brand_id
      }
      if(this.$route.params.id){
        filters.brand_id = this.$route.params.id
        await self.$store.dispatch('Car_models/show', this.$route.params.id ).then(val => {
          if(val.size_spot){
            self.data.size_spot_id = val.size_spot
          }
        });
      } 

      await self.$store.dispatch('Car_models/getListAll',filters);
      await self.$store.dispatch('Size_spots/getListAll',{});
    },
    data() {
      return {
        parentStoreName: 'Car_brands',
        parentUrlKey:"brand_id",
        storeName: 'Car_models',
        title: "Marcas",
        filteredAttributes: ["car_picture"],
        car_picture: "",
        data: {
          name: '',
          brand_id: '',
          car_picture: undefined,
          size_spot_id:'',
          length:'',
          width:'',
        },
      }
    },
    methods: {
      onSelectedPicture(file) {
        const self = this;
        this.data.car_picture = file;

        let fr = new FileReader();
        fr.onload = function () {
          self.car_picture = fr.result;
        };
        fr.onerror = function () {
          self.car_picture = '';
        };
        fr.readAsDataURL(this.data.car_picture);
      }
    }
  }
</script>
